import { omit } from 'lodash-es'
import { computed } from '@preact/signals-core'

import { current } from '$store/session'
import { details } from '$store/session/tokens'

import { Token } from '$api/common'
import { AuthAPI } from '$api/auth'
import { MfaAuthAPI } from '$api/mfa-auth'

// Add multiple API sources here
const createSources = (token: Token) => {
  const auth = new AuthAPI(token)
  const mfaAuth = new MfaAuthAPI(token)

  return {
    auth,
    mfaAuth
  }
}

/**
 * Type: Readonly
 */
export const sources = computed(() =>
  details.value.map(({ token, ...rest }) => ({
    ...rest,
    ...createSources(token)
  }))
)

/**
 * State: Computed
 */
export const activeSource = computed(() =>
  sources.value.find(({ user_id }) => user_id === current.value)
)
export const hasActiveSource = computed(() => !!activeSource.value)

/**
 * State: Computed
 */
export const api = computed(() => {
  const defaultSource = createSources(null)

  const source = omit(activeSource.value || defaultSource, ['user_id', 'id'])

  return source as Required<typeof source>
})

export type Sources = (typeof api)['value']

export default api
